defineDs('DanskeSpil/Domain/PlayTogether/Scripts/Templates/Common/FlowProgressBar',
  [
    'Shared/Framework/Mithril/Scripts/Core/Mithril'
  ],
  function (m) {
    // Return:
    const FlowProgressBar = (steps, currentStep) => {
      const currentStepIndex = steps.indexOf(currentStep());
      return m('.play-together-flow-progress-bar', steps.map((ignoreStepItem, index) => {
        return m('.flow-progress-bar__item', {
          class: currentStepIndex >= index ? 'flow-progress-bar__item--active' : ''
        });
      }));
    };
    // Public functions:
    return FlowProgressBar;
  });
